module.exports = __webpack_public_path__ + "static/media/bottomshape.77982eeb.png";